import { useEffect, useState } from "react";

import { fileImportApi } from "@/main/api";
import { FileTypeEnum } from "@/main/services/enum/FileTypeEnum";
import { getTranslateByKey } from "@/main/services/utils";
import { viewPdfNewTab } from "@/main/services/utilsFile";

import * as S from "./styles";

function DesiredPartMappingPart() {
	const [desiredPartBase64, setDesiredPartBase64] = useState("");

	function handleOpenModalDesiredPart() {
		if (desiredPartBase64 === "") return;
		viewPdfNewTab(desiredPartBase64);
	}
	async function loadFile() {
		try {
			const {
				data: { result },
			} = await fileImportApi.getFile(FileTypeEnum.Inventory);
			setDesiredPartBase64(result.file);
		} catch {}
	}

	useEffect(() => {
		loadFile();
	}, []);

	return (
		<S.LabelText>
			{getTranslateByKey("information.desiredPartInventory")},
			<S.LinkText $isDisabled={desiredPartBase64 === ""} onClick={handleOpenModalDesiredPart}>
				{getTranslateByKey("information.clickHere")}
			</S.LinkText>
		</S.LabelText>
	);
}

export default DesiredPartMappingPart;
